<template>
  <div class="cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-16 cf-padding-bottom-16">
    <h2 class="cf-title cf-title--2">
      Open Tab
    </h2>

    <div
      ref="carousel"
      class="cf-carousel__items"
    >
      <div class="cf-carousel__item">
        <div class="cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-12">
          <div
            v-if="content.OpenTabOnboarding1.metadata.imageUrl"
            class="onboarding__image"
            :style="{ backgroundImage: `url('${content.OpenTabOnboarding1.metadata.imageUrl}')` }"
          />

          <h2 class="cf-title cf-title--2">
            {{ content.OpenTabOnboarding1.title }}
          </h2>

          <p class="cf-subtitle cf-subtitle--3">
            {{ content.OpenTabOnboarding1.metadata.subtitle }}
          </p>
        </div>
      </div>

      <div class="cf-carousel__item">
        <div class="cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-12">
          <div
            v-if="content.OpenTabOnboarding2.metadata.imageUrl"
            class="onboarding__image"
            :style="{ backgroundImage: `url('${content.OpenTabOnboarding2.metadata.imageUrl}')` }"
          />

          <h2 class="cf-title cf-title--2">
            {{ content.OpenTabOnboarding2.title }}
          </h2>

          <p class="cf-subtitle cf-subtitle--3">
            {{ content.OpenTabOnboarding2.metadata.subtitle }}
          </p>
        </div>
      </div>
    </div>

    <div class="cf-carousel__dots">
      <div
        class="cf-carousel__dot"
        :class="page === 1 && 'cf-carousel__dot--active'"
      />
      <div
        class="cf-carousel__dot"
        :class="page === 2 && 'cf-carousel__dot--active'"
      />
    </div>

    <button
      type="button"
      class="cf-button cf-button--primary cf-button--lg cf-button--fill"
      @click="closeOpenTabOnboarding"
    >
      {{ content.OpenTabOnboarding1.metadata.cta }}
    </button>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'OpenTabOnboarding',

    data() {
      return {
        page: 1
      };
    },

    computed: {
      ...mapGetters('content', ['content'])
    },

    mounted() {
      this.mountedHandler();
    },

    beforeUnmount() {
      this.beforeDestroyHandler();
    },

    methods: {
      closeOpenTabOnboarding() {
        this.$closeModal('openTabOnboarding');
      },

      mountedHandler() {
        this.$refs.carousel.addEventListener('scroll', this.scrollHandler);
      },

      beforeDestroyHandler() {
        this.$refs.carousel.removeEventListener('scroll', this.scrollHandler);
      },

      scrollHandler() {
        const itemWidth = this.$refs.carousel.children[0].clientWidth;
        const containerWidth = this.$refs.carousel.scrollWidth;
        const scrolled = this.$refs.carousel.scrollLeft;
        const items = containerWidth / itemWidth;

        const result = ((scrolled / containerWidth) * items) + 1;

        if (Number.isInteger(result)) {
          this.page = result;
        }
      }
    }
  };
</script>

<style lang="sass">
  .onboarding__image
    width: 100%
    height: 275px
    background-repeat: no-repeat
    background-position: center top
    background-size: cover
</style>
